export default __webpack_public_path__ + "static/media/phone.a73bad53.svg";